import { useState } from 'react';
import { fetchWithAuth } from './authHelpers';

const useEventNames = () => {
    const [eventNames, setEventNames] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchEventNames = async (seasonId) => {
        try {
            const response = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/events/season/${seasonId}/names`, 'GET');
            if (!response.ok) {
                throw new Error('Failed to fetch event names');
            }
            const data = await response.json();
            setEventNames(data);
        } catch (err) {
            setError("Error fetching event names");
        } finally {
            setLoading(false);
        }
    };
    ;

    return { fetchEventNames, eventNames, loading, error };
};
export default useEventNames;